"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var Auth_1 = require("../helpers/Auth");
var Logger_1 = require("./Logger");
// Constants
var TOKEN_NAME = "FOXSSOACCT";
var PREPROD_TOKEN_NAME = "qFOXSSOACCT";
// Auth Main
var Auth = /** @class */ (function (_super) {
    __extends(Auth, _super);
    function Auth() {
        var _this = _super.call(this) || this;
        _this.isDebug = false; // default turned off
        return _this;
    }
    Auth.prototype.init = function (_a) {
        var _b = _a.domain, domain = _b === void 0 ? "" : _b, _c = _a.preProd, preProd = _c === void 0 ? false : _c, _d = _a.debug, debug = _d === void 0 ? false : _d;
        this.isDebug = debug;
        this.domain = domain;
        this.name = preProd ? PREPROD_TOKEN_NAME : TOKEN_NAME;
        this.token = this.getToken();
        if (this.token) {
            try {
                this.jwt = jwt_decode_1.default(this.token.accessToken);
            }
            catch (error) {
                this.jwt = undefined;
                Logger_1.logInfo("Auth", "parse jwt");
                Logger_1.logError(error);
            }
        }
        if (this.isDebug) {
            Logger_1.logDebug("Auth: name, token, jwt", {
                name: this.name,
                token: this.token,
                jwt: this.jwt,
            });
        }
        Logger_1.logInfo("Auth", "Initialized");
    };
    Auth.prototype.getToken = function () {
        var token = this.name ? this.get(this.name) : undefined;
        if (this.isDebug) {
            Logger_1.logDebug("Auth: get token", token);
        }
        else {
            Logger_1.logInfo("Auth", "get token");
        }
        return token;
    };
    Auth.prototype.getAccessToken = function () {
        Logger_1.logInfo("Auth", "get access token");
        var token = this.getToken();
        return token ? token === null || token === void 0 ? void 0 : token.accessToken : undefined;
    };
    Auth.prototype.setToken = function (authToken, setCookieOptions) {
        Logger_1.logInfo("Auth", "set token");
        try {
            if (authToken) {
                var options = Auth_1.getCookieOptions(authToken, setCookieOptions);
                // set token
                this.token = authToken;
                this.jwt = jwt_decode_1.default(authToken.accessToken);
                if (this.name) {
                    this.set(this.name, this.token, options);
                }
                if (this.isDebug) {
                }
            }
            else {
                throw Error("cannot set empty token");
            }
        }
        catch (e) {
            Logger_1.logError(e);
        }
    };
    Auth.prototype.removeToken = function () {
        Logger_1.logInfo("Auth", "remove token");
        var options = Auth_1.getCookieOptions(undefined);
        if (this.name) {
            this.remove(this.name); // remove token from root path
            this.remove(this.name, options); // remove token from domain path
        }
        this.token = undefined;
        this.jwt = undefined;
        if (this.isDebug) {
            Logger_1.logDebug("Auth: remove token", {
                token: this.token,
                jwt: this.jwt,
            });
        }
    };
    Auth.prototype.isUserSignedIn = function () {
        return !this.isUserAnonymous();
    };
    Auth.prototype.isUserAnonymous = function () {
        return !!this.jwt && this.jwt.atype === "anonymous";
    };
    Auth.prototype.getMvpdId = function () {
        return this.jwt ? this.jwt.mvpdid : undefined;
    };
    Auth.prototype.getUserId = function () {
        return this.jwt ? this.jwt.uid : undefined;
    };
    return Auth;
}(universal_cookie_1.default));
exports.AuthStore = new Auth();
//# sourceMappingURL=Auth.js.map